// Anthology personalization engine - Canopy 7.4 rewrite.
// Handles the "standard" text/date input types: House Font, Initials (with
// virtual keyboard), Special Date, Roman Numeral Date, Coordinates, Symbol.
// Upload-based types (Handwriting/Soundwave/Fingerprint/Photo) need no JS at
// all - the CloudLift app embed finds their container divs directly.
// Minihearts/CustomPet/Heart Names are ported separately (anthology-minihearts.js,
// anthology-pet.js, anthology-heartnames.js).
//
// Customization-type selector: originally a <select>, now an icon-button
// radio group (see product-customizer.liquid / product-steps.css) -
// showActivePanel() reads whichever of the two is present so either markup
// works. Layouts with no selector at all (dual fingerprint upload, locket
// cover + inside uploads) just show every panel; they still need the form
// association below, which is why it does not depend on the selector.
//
// Two-sided pieces: an "Engraving sides" radio row (Front / Front + Back,
// submitted as properties[Engraving sides]) picks which .anthology-side-group
// blocks are shown. Every group has its OWN type selector and panels, so the
// front and back can use different customization types (Handwriting on the
// front, Special Date on the back). One-sided pieces have a single group (or
// none, for the fixed layouts). The fields of a hidden side are disabled so
// they are NOT submitted (including the hidden inputs the Upload Lift widget
// injects for that side's upload).
//
// Block Builder (block jewelry, tag "Block Builder"): the letters field(s)
// follow the "Block Count" variant - capped at that many characters, filtered
// to the product's allowed characters, and add-to-cart is blocked until every
// field has exactly Block Count characters (one per block). "Block Pair"
// earrings have a left and a right field, Block Count characters each.
(function () {
  if (customElements.get('anthology-customizer')) return;

  // The customizer block renders outside the main product <form> (Canopy only
  // wraps the buy buttons in it), so its inputs - and the hidden inputs the
  // Upload Lift widget injects (properties[...], _upload_id[]) - would never
  // be sent with add-to-cart. Point them all at the main product form via
  // the form="" attribute; also overrides Upload Lift binding itself to a
  // PageFly card form for the same product.
  var FIELD_SELECTOR = 'input[name^="properties["], select[name^="properties["], ' +
    'textarea[name^="properties["], input[name="_upload_id[]"]';

  function associateFields(root) {
    var form = document.querySelector('form.js-product-form-main');
    var formId = form && form.getAttribute('id');
    if (!formId) return;
    root.querySelectorAll(FIELD_SELECTOR).forEach(function (el) {
      if (el.getAttribute('form') !== formId) el.setAttribute('form', formId);
    });
  }

  function watchFields() {
    var root = document.querySelector('.product-info') || document.body;
    associateFields(root);
    var form = document.querySelector('form.js-product-form-main');
    if (form) {
      form.addEventListener('submit', function () { associateFields(root); }, true);
    }
    new MutationObserver(function () { associateFields(root); })
      .observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['form'] });
  }

  // The selected "Block Count" variant value (0 when the product has none).
  // Listed buttons or the dropdown picker, whichever the variant picker uses.
  function selectedBlockCount() {
    var fieldset = document.querySelector('variant-picker [data-option="Block Count"]');
    if (!fieldset) return 0;
    var value = null;
    var checked = fieldset.querySelector('input.js-option:checked');
    if (checked) {
      value = checked.value;
    } else {
      var selected = fieldset.querySelector('.custom-select__option[aria-selected="true"]');
      if (selected) value = selected.dataset.value;
    }
    var n = parseInt(value, 10);
    return n > 0 ? n : 0;
  }

  function charWord(n) {
    return n + (n === 1 ? ' character' : ' characters');
  }

  var ROMAN_NUMERALS = [
    [1000, 'M'], [900, 'CM'], [500, 'D'], [400, 'CD'],
    [100, 'C'], [90, 'XC'], [50, 'L'], [40, 'XL'],
    [10, 'X'], [9, 'IX'], [5, 'V'], [4, 'IV'], [1, 'I']
  ];

  function toRoman(num) {
    if (!num || num < 1) return '';
    var result = '';
    for (var i = 0; i < ROMAN_NUMERALS.length; i++) {
      while (num >= ROMAN_NUMERALS[i][0]) {
        result += ROMAN_NUMERALS[i][1];
        num -= ROMAN_NUMERALS[i][0];
      }
    }
    return result;
  }

  function formatRomanDate(isoDate) {
    if (!isoDate) return '';
    var parts = isoDate.split('-');
    if (parts.length !== 3) return '';
    var year = parseInt(parts[0], 10);
    var month = parseInt(parts[1], 10);
    var day = parseInt(parts[2], 10);
    return [toRoman(month), toRoman(day), toRoman(year)].join('.');
  }

  class AnthologyCustomizer extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('.anthology-customize-select');
      this.typeInputs = this.querySelectorAll('.anthology-customize-type-input');
      this.panels = this.querySelectorAll('.anthology-customize-panel');
      if (!this.panels.length) return;

      if (this.select || this.typeInputs.length) {
        if (this.select) {
          this.select.addEventListener('change', this.showActivePanel.bind(this));
        }
        this.typeInputs.forEach((input) => {
          input.addEventListener('change', this.showActivePanel.bind(this));
        });

        this.showActivePanel();
      }

      this.checks = [];
      this.initInitialsKeyboard();
      this.initRomanDate();
      this.initBlockBuilder();
      this.initSides();
      this.initRequired();
      this.initValidation();
      watchFields();
    }

    // Add-to-cart checks. The product form is novalidate and adds to cart from
    // its own submit handler, so the browser never enforces "required" or a
    // length - each feature pushes a function onto this.checks that returns an
    // error message ('' when fine), and one capturing submit listener (runs
    // before the theme's handler) blocks the add and shows the first message.
    initValidation() {
      var self = this;
      if (!this.checks.length) return;

      var msg = document.createElement('div');
      msg.className = 'anthology-customize-panel__error';
      msg.setAttribute('role', 'alert');
      msg.hidden = true;
      this.appendChild(msg);

      // "Not ready with your customization details?" (Buy Now, Customize
      // Later) promises an email after checkout, so it skips every check.
      function customizeLater() {
        try {
          return localStorage.getItem('anthology_customize_later') === 'true';
        } catch (e) {
          return false;
        }
      }

      function firstError() {
        if (customizeLater()) return '';
        for (var i = 0; i < self.checks.length; i++) {
          var err = self.checks[i]();
          if (err) return err;
        }
        return '';
      }

      document.addEventListener('submit', function (evt) {
        var form = evt.target;
        if (!form || !form.classList || !form.classList.contains('js-product-form-main')) return;
        var err = firstError();
        msg.hidden = !err;
        if (!err) return;
        evt.preventDefault();
        evt.stopImmediatePropagation();
        msg.textContent = err;
        self.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, true);

      function clearIfFixed() {
        if (!msg.hidden && !firstError()) msg.hidden = true;
      }
      this.addEventListener('input', clearIfFixed);
      this.addEventListener('change', clearIfFixed);
    }

    // Required radio groups (Character Picker, Ring Size Picker).
    initRequired() {
      var self = this;
      var MESSAGES = {
        'properties[Character]': 'Please choose a character before adding to bag.',
        'properties[Ring Size]': 'Please choose a ring size before adding to bag.'
      };
      var names = [];
      this.querySelectorAll('input[type="radio"][required]').forEach(function (r) {
        if (names.indexOf(r.name) === -1) names.push(r.name);
      });
      names.forEach(function (name) {
        self.checks.push(function () {
          var group = Array.prototype.filter.call(self.querySelectorAll('input[type="radio"]'), function (i) {
            return i.name === name;
          });
          if (!group.length || group[0].disabled) return '';
          if (group.some(function (i) { return i.checked; })) return '';
          return MESSAGES[name] || 'Please make a selection above before adding to bag.';
        });
      });
    }

    // Block Builder: one character per block. Typing is uppercased, filtered to
    // data-block-chars and capped at the selected Block Count; the symbol keys
    // (tag "Block Symbols") type into whichever field was used last. The Block
    // Count is re-read on its own change and on the picker's on:variant:change,
    // because the variant picker re-renders its buttons after every change.
    initBlockBuilder() {
      var inputs = Array.prototype.slice.call(this.querySelectorAll('.anthology-block-input'));
      if (!inputs.length) return;
      var hint = this.querySelector('.anthology-block-hint');
      var notAllowed = new RegExp('[^' + (this.dataset.blockChars || 'A-Z0-9') + ']', 'gu');
      var pair = inputs.length > 1;
      var active = inputs[0];

      function length(value) {
        return Array.from(value).length;
      }

      function clean(input) {
        var n = selectedBlockCount();
        var chars = Array.from(input.value.toUpperCase().replace(notAllowed, ''));
        if (n && chars.length > n) chars = chars.slice(0, n);
        var value = chars.join('');
        if (value !== input.value) input.value = value;
      }

      function apply() {
        var n = selectedBlockCount();
        inputs.forEach(function (input) {
          clean(input);
          input.placeholder = n ? charWord(n) : '';
        });
        if (hint) {
          hint.textContent = n
            ? 'Exactly ' + charWord(n) + (pair ? ' on each earring' : '') + ', one per block'
            : '';
        }
      }

      inputs.forEach(function (input) {
        input.addEventListener('input', function () { clean(input); });
        input.addEventListener('focus', function () { active = input; });
      });

      this.querySelectorAll('.anthology-block-key').forEach(function (key) {
        key.addEventListener('click', function () {
          active.value += key.textContent.trim();
          clean(active);
          active.dispatchEvent(new Event('input', { bubbles: true }));
          active.focus();
        });
      });

      document.addEventListener('change', function (e) {
        if (e.target.closest && e.target.closest('[data-option="Block Count"]')) apply();
      });
      document.addEventListener('on:variant:change', apply);
      apply();

      this.checks.push(function () {
        var n = selectedBlockCount();
        if (!n) return '';
        for (var i = 0; i < inputs.length; i++) {
          var have = length(inputs[i].value);
          if (have !== n) {
            var where = pair ? (i === 0 ? ' for the left earring' : ' for the right earring') : '';
            return 'Please enter ' + charWord(n) + where + ', one per block (you have ' + have + ').';
          }
        }
        return '';
      });
    }

    // Each side group has its own type selector and panels; layouts without
    // groups treat the whole element as one group.
    showActivePanel() {
      var groups = this.querySelectorAll('.anthology-side-group');
      var list = groups.length ? Array.prototype.slice.call(groups) : [this];
      list.forEach(function (group) {
        var select = group.querySelector('.anthology-customize-select');
        var checked = group.querySelector('.anthology-customize-type-input:checked');
        var active = select ? select.value : (checked ? checked.value : null);
        if (active === null) return;
        group.querySelectorAll('.anthology-customize-panel').forEach(function (panel) {
          panel.hidden = panel.dataset.panel !== active;
        });
      });
    }

    // One on-screen keyboard per Initials input (a two-sided piece has a front
    // and a back input, each with its own keyboard in the same block).
    initInitialsKeyboard() {
      this.querySelectorAll('[data-panel="initials"] .anthology-keys-input').forEach(function (input) {
        var block = input.parentElement;
        block.querySelectorAll('.anthology-key').forEach(function (key) {
          key.addEventListener('click', function () {
            var maxLength = parseInt(input.getAttribute('maxlength'), 10) || Infinity;
            if (input.value.length >= maxLength) return;
            input.value += key.textContent;
            input.dispatchEvent(new Event('input', { bubbles: true }));
          });
        });
      });
    }

    // One date -> roman numeral conversion per date input (front and back).
    initRomanDate() {
      this.querySelectorAll('[data-panel="roman-numeral-date"] .anthology-roman-date-input').forEach(function (dateInput) {
        var result = dateInput.parentElement.querySelector('.anthology-roman-date-result');
        if (!result) return;

        // A disabled field is never submitted with the form, so the computed
        // roman-numeral date would be dropped from the cart line. Keep it
        // read-only (same look) instead.
        result.disabled = false;
        result.readOnly = true;
        result.style.background = '#f2f0ec';
        result.style.color = 'rgba(0, 0, 0, 0.5)';

        dateInput.addEventListener('change', function () {
          result.value = formatRomanDate(dateInput.value);
        });
      });
    }

    // Front / Front + Back. Shows the chosen side groups and disables the
    // fields of the hidden ones so they are not sent with the order. Upload
    // Lift adds its hidden inputs after an upload, so a MutationObserver keeps
    // the disabled state in step.
    initSides() {
      var self = this;
      var radios = this.querySelectorAll('.anthology-side-input');
      if (!radios.length) return;

      function chosen() {
        var checked = Array.prototype.find.call(radios, function (r) { return r.checked; });
        return checked ? checked.value : 'Front';
      }

      function sync() {
        var showBack = chosen() !== 'Front';
        self.querySelectorAll('.anthology-side-group').forEach(function (group) {
          var on = group.dataset.side === 'back' ? showBack : true;
          group.hidden = !on;
          group.querySelectorAll(FIELD_SELECTOR).forEach(function (el) {
            if (el.disabled === on) el.disabled = !on;
          });
        });
      }

      radios.forEach(function (r) { r.addEventListener('change', sync); });

      var queued = false;
      new MutationObserver(function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () {
          queued = false;
          sync();
        });
      }).observe(this, { childList: true, subtree: true });

      sync();
    }
  }

  customElements.define('anthology-customizer', AnthologyCustomizer);
})();

// House Font picker: three engraving styles (Script / Sans / Serif) under
// every House Font text box (front and back). Tiles preview the font, the
// text box previews the typed text in the chosen font, and the choice is sent
// as the "Font" / "FontBack" order property - only while the text box has
// text, so a customer who picks another customization type does not get a
// stray Font line on the order. Built in JS so it needs no template changes;
// Google Fonts are only requested when a House Font panel exists.
(function () {
  var FONTS = [
    { key: 'script', label: 'Script', family: '"Great Vibes", cursive', value: 'Script - Great Vibes' },
    { key: 'sans', label: 'Sans', family: '"Montserrat", sans-serif', value: 'Sans - Montserrat' },
    { key: 'serif', label: 'Serif', family: '"Playfair Display", serif', value: 'Serif - Playfair Display' }
  ];

  function injectAssets() {
    if (document.getElementById('anthology-fontpicker-css')) return;
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=Great+Vibes&family=Montserrat:wght@400&family=Playfair+Display:wght@400&display=swap';
    document.head.appendChild(link);

    var style = document.createElement('style');
    style.id = 'anthology-fontpicker-css';
    style.textContent =
      '.anthology-font-picker{margin-top:8px}' +
      '.anthology-font-picker__options{display:flex;gap:0}' +
      '.anthology-font-option{box-sizing:border-box;flex:1 1 0;min-width:0;margin:0 -1px 0 0;padding:6px 4px;' +
      'border:1px solid rgba(0,0,0,.2);background:#fff;cursor:pointer;display:flex;flex-direction:row;align-items:center;justify-content:center;gap:6px}' +
      '.anthology-font-option__sample{font-size:22px;line-height:1.1;color:#000;text-transform:none;letter-spacing:0}' +
      '.anthology-font-option__name{font-size:11px;letter-spacing:.04em;color:#000}' +
      '.anthology-font-picker input[type=radio]:checked+.anthology-font-option{border-color:#000;background:#f4f4f4;position:relative;z-index:1}' +
      '.anthology-font-picker input[type=radio]:focus-visible+.anthology-font-option{outline:2px solid #000;outline-offset:2px;z-index:2}';
    document.head.appendChild(style);
  }

  function build(panel) {
    if (panel.dataset.fontPicker) return;
    var text = panel.querySelector('input[type="text"]');
    if (!text) return;
    panel.dataset.fontPicker = '1';
    injectAssets();

    var isBack = /Back/.test(text.name);
    var sfx = isBack ? '-back' : '';
    var group = 'anthology-font' + sfx;

    var wrap = document.createElement('div');
    wrap.className = 'anthology-font-picker';
    wrap.setAttribute('role', 'radiogroup');
    wrap.setAttribute('aria-label', 'Choose your font');

    var options = document.createElement('div');
    options.className = 'anthology-font-picker__options';
    wrap.appendChild(options);

    var hidden = document.createElement('input');
    hidden.type = 'hidden';
    hidden.name = 'properties[' + (isBack ? 'FontBack' : 'Font') + ']';
    hidden.value = '';

    var current = FONTS[0];

    function sync() {
      text.style.fontFamily = current.family;
      hidden.value = text.value.trim() ? current.value : '';
    }

    FONTS.forEach(function (font, i) {
      var id = group + '-' + font.key;
      var radio = document.createElement('input');
      radio.type = 'radio';
      radio.className = 'visually-hidden';
      radio.name = group;
      radio.id = id;
      radio.value = font.key;
      if (i === 0) radio.checked = true;
      radio.addEventListener('change', function () {
        current = font;
        sync();
      });

      var tile = document.createElement('label');
      tile.className = 'anthology-font-option';
      tile.setAttribute('for', id);
      var sample = document.createElement('span');
      sample.className = 'anthology-font-option__sample';
      sample.style.fontFamily = font.family;
      sample.textContent = 'Aa';
      var name = document.createElement('span');
      name.className = 'anthology-font-option__name';
      name.textContent = font.label;
      tile.appendChild(sample);
      tile.appendChild(name);

      options.appendChild(radio);
      options.appendChild(tile);
    });

    text.addEventListener('input', sync);
    panel.appendChild(wrap);
    panel.appendChild(hidden);
    sync();
  }

  function scan() {
    document.querySelectorAll('.anthology-customize-panel[data-panel="house-font"]').forEach(build);
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      scan();
    });
  }

  function init() {
    scan();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


(function () {
  function balanceCustomizationTiles(root) {
    root.querySelectorAll('.anthology-customize-type .anthology-customize-type__btns').forEach(function (row) {
      if (row.dataset.balancedTiles) return;
      row.dataset.balancedTiles = 'true';
      var tiles = Array.from(row.children).filter(function (child) {
        return child.matches('.anthology-customize-type__option');
      });
      if (!tiles.length) return;
      var previousColumns = '';
      function arrange(width) {
        if (!width) return;
        var minimumWidth = width <= 440 ? 100 : 112;
        var capacity = Math.max(1, Math.floor(width / minimumWidth));
        var rowCount = Math.ceil(tiles.length / capacity);
        var perRow = Math.floor(tiles.length / rowCount);
        var extra = tiles.length % rowCount;
        var columns = perRow + (extra ? 1 : 0);
        var signature = rowCount + ':' + columns + ':' + extra;
        if (signature === previousColumns) return;
        previousColumns = signature;
        row.style.gridTemplateColumns = 'repeat(' + (columns * 2) + ', minmax(0, 1fr))';
        var tileIndex = 0;
        for (var rowIndex = 0; rowIndex < rowCount; rowIndex++) {
          var count = perRow + (rowIndex < extra ? 1 : 0);
          var offset = columns - count;
          for (var column = 0; column < count; column++) {
            var tile = tiles[tileIndex++];
            tile.style.gridColumn = (offset + column * 2 + 1) + ' / span 2';
            tile.style.gridRow = String(rowIndex + 1);
          }
        }
      }
      arrange(row.getBoundingClientRect().width);
      var observer = new ResizeObserver(function (entries) {
        arrange(entries[0].contentRect.width);
      });
      observer.observe(row);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      balanceCustomizationTiles(document);
    }, { once: true });
  } else {
    balanceCustomizationTiles(document);
  }
  document.addEventListener('shopify:section:load', function (event) {
    balanceCustomizationTiles(event.target);
  });
})();
